// Shared numeric tuning values. Tweak here rather than chasing magic numbers
// through the rest of the codebase.

// Layout / simulation
export const SPACE_CENTER = 1500
export const INIT_JITTER = 40        // fallback spread when x/y aren't baked
export const MIN_ZOOM = 0.015
export const FIT_VIEW_DELAY_MS = 100
export const TOUCH_PAUSE_DELAY_MS = 100

// Breakpoint shared between JS and CSS
export const MOBILE_BREAKPOINT = '(max-width: 640px)'
export const TOUCH_QUERY = '(pointer: coarse)'

// Render
export const DESKTOP_PIXEL_RATIO = 2
export const TOUCH_PIXEL_RATIO = 1.5

// Point sizing
export const POINT_SIZE_MIN = 5
export const POINT_SIZE_RANGE = 16

// Edge alpha envelope (per active-edge set)
export const EDGE_ALPHA_BASE = 0.2
export const EDGE_ALPHA_RANGE = 0.25

// Cosmos visual tuning
export const LINK_VIS_DISTANCE_RANGE: [number, number] = [50, 150]
export const LINK_VIS_MIN_TRANSPARENCY = 0.3
export const POINT_GREYOUT_OPACITY = 0.15
export const LINK_GREYOUT_OPACITY = 0.2

// Animation timings
export const RECENTER_MS = 600
export const PLAYER_FOCUS_MS = 700
export const PLAYER_FOCUS_ZOOM = 8

// Tooltip layout
export const TOOLTIP_PAD = 12
export const TOUCH_TOOLTIP_LIFT = 44
export const SELECT_PLAYER_TIP_X_RATIO = 0.6
export const SELECT_PLAYER_TIP_Y_RATIO = 0.15

// Search UI
export const MAX_SEARCH_RESULTS = 20
export const SEARCH_BLUR_MS = 150

// Filter UI
export const DEFAULT_FILTER_MIN = 1

// Team node imagery (per-team offscreen circle with stroke, used as the
// point image in place of a solid-color point).
export const TEAM_IMAGE_RES = 128
export const TEAM_STROKE_RATIO = 0.05  // fraction of diameter
